export default "__VITE_ASSET__DsPUudUf__"